/*! comscore-metadata.js */

/**
 * @description
 * We use the comscore names here since people should only be using this class to gather
 * information to send to Comscore. For values themselves, top level BMMR methods should be used.
 * @constructor ComscoreMetadata
 */
class ComscoreMetadata {

    /**
     * @constructs ComscoreMetadata
     * @param {string} ntStEp
     * @param {string} nsStTy
     * @param {string} bbPubD
     * @param {string} c5
     */
    constructor({ ntStEp = null, nsStTy = null, bbPubD = null, c5 = null }) {
        this.ntStEp = ntStEp;
        this.nsStTy = nsStTy;
        this.bbPubD = bbPubD;
        this.c5 = c5;
    }

    /**
     * Episode Name
     * @method
     * @returns {string|null}
     */
    getNtStEp() {
        return this.ntStEp;
    }

    /**
     * Form Type
     * @method
     * @returns {string|null}
     */
    getNsStTy() {
        return this.nsStTy;
    }

    /**
     * Bloomberg publish date
     * @method
     * @returns {string|null}
     */
    getBbPubD() {
        return this.bbPubD;
    }

    /**
     * Content Type
     * @description (02 for VOD, 03 for LIVE, 09 for pre-roll, etc.)
     * @method
     * @returns {string|null}
     */
    getC5() {
        return this.c5;
    }
}

export default ComscoreMetadata;
